module.exports = __webpack_public_path__ + "img/display_count.ccfcc01b.svg";